import { useLocation } from "react-router-dom";
import PageHeader from "../../../../Component/BasicComponents/HeaderBreadCrumbs";
import CustomerDcrSummaryTable from "./component/CustomerDcrSummaryTable";
import { useEffect, useState } from "react";
import SgpiOutSummaryTable from "./component/SgpiOutSummaryTable";
import RcpaSummaryTable from "./component/RcpaSummaryTable";
import EmployeeProfileCard from "../../../Employee/components/EmployeeProfileCard";
import { H4 } from "../../../../AbstractElements";
import InternalNote from "./component/InternalNote";
import BeatOutlet from "./component/BeatOutlet";

const CustomerOrgScreen=()=>{
const location=useLocation();
// const[outletOrgId,setOutletOrgId]=useState()
    console.log('location sai data',location.state)
    // useEffect(()=>{
    //     if(location.state){
    //         setOutletOrgId(location.state.OrgSelectedData.OutletOrgId)
    //     }
    // },[location.state])

      const RequiredFiled = {
    Name:"OutletContactName",
    EmployeeCode:"OutletCode",
    OutletType: "OutletTypeName",
    Classification:"ClassificationName",
    OutletName:'OutletName',
    LegacyCode:'OutletCode',
    ContactName:'OutletContactName',
    Contact:'OutletContactNo',
    Email:'OutletEmail',
    OpeningDate:'OutletOpeningDate',
    Salutation:'OutletSalutation',
    DateOfBirth:'OutletContactBday',
    MaritalStatus:'OutletMaritalStatus',
    Anniversary:'OutletContactAnniversary',
    Potential:'OutletPotential',
    Qualification:'OutletQualification',
    Regno:'OutletRegno',
    Status:'OutletStatus',
    // ProfilePicture: "ProfilePicture",
  };

   const customStyles ={
    container:{ 
      display: "flex",
      // flexDirection: "row",
      alignItems: "center",
      backgroundColor: "#e6f7f9",
      padding: "24px",
      borderRadius: "16px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      width: "100%",
      maxWidth: "100%",
      flex: "1 1 0",
      gap:'6%',
      height: '95%'
    },
    imageContainer: {
      width: "70%",
      height: "50%",
      borderRadius: "50%",
      overflow: "hidden",
      marginBottom: "16px",
      backgroundColor: "#fff",
      marginLeft:'16xp'
    },
    detailsContainer: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
      gap: "40px",
      width: "100%",
    },
    // imageOuterContainer:{
        //  display: "flex",
        // flexDirection: "column",
        // width: "36%",
        // marginLeft:'10px',
        // alignItems: "center",
        // justifyContent: "center",
    // }

  }

const OrgDetails={
  BrandFocus:"BrandFocus",
    VisitFrequency:"VisitFq",
    Tags:"Tags",
    Address:"DefaultAddress",
    OrgUnit :"OrgUnitName",
    Town :"TownName"


}

const formatKeyToLabel = (key: string): string => {
  return key.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before capital letters
};
const displayValue = (value?: string | null): string => {
  return value?.toString().trim() ? value : 'Not Available';
};


    return(
          <div className="p-2">
      <PageHeader title="Outlet Organization"
    //   buttons={[
    //     {
    //         label:'Edit',
    //         onClick:editCustomerDetailHandler,
    //         color:'#2e8dd3'
    //     }
    //   ]} 
      />
  
      <div className="row mb-3">
        <div className="col-md-12" >
          <EmployeeProfileCard media={location?.state?.OrgSelectedData?.employeeData?.OutletMediaId} profileEdit={false} customStyles={customStyles} requiredFields={RequiredFiled} employeeData={location.state.OrgSelectedData.employeeData} showStatusToggle={false}  />
        </div>
      </div>

<div className="row mb-3">
  <div
    className="col-md-12"
    style={{
      display: "flex",
      backgroundColor: "#e6f7f9",
      padding: "24px",
      borderRadius: "16px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      width: "100%",
      maxWidth: "100%",
      flex: "1 1 0",
      gap: "25px",
      flexDirection:'column',
      margin:'0px 10px 10px 10px'
    }}
  >
    <H4>Outlet Org View</H4>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "16px",
        width: "100%",
      }}
    >
      {Object.entries(OrgDetails).map(([label, key], index) => (
        <div key={index}>
          <strong>{formatKeyToLabel(label)}:</strong>{" "}
          {displayValue(location.state.OrgSelectedData?.[key])}
        </div>
      ))}
    </div>
  </div>
</div>


  <div className="row mb-3">
              <div className="col-12">
          <BeatOutlet OutletOrgId={location.state.OrgSelectedData.OutletOrgId} />
        </div>
        </div>

  
      <div className="row mb-3">
        <div className="col-12">
          <CustomerDcrSummaryTable OutletOrgId={location.state.OrgSelectedData.OutletOrgId} />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12">
          <SgpiOutSummaryTable OutletOrgId={location.state.OrgSelectedData.OutletOrgId} />
        </div>
      </div>
       <div className="row mb-3">
        <div className="col-12">
          <RcpaSummaryTable OutletOrgId={location.state.OrgSelectedData.OutletOrgId} />
        </div>
      </div>

<div className="row mb-3">
        <div className="col-12">
          <InternalNote OutletOrgId={location.state.OrgSelectedData.OutletOrgId} />
        </div>
    
        </div>
        


    </div>
    )
}
export default CustomerOrgScreen;